// Titanium Wares - cart "Add to your order" + Add (snippets/tw-cart-upsell.liquid), owner 22/10/2026.
// Same pattern as assets/st-bundle.js: one /cart/add.js with the drawer's section ids, then the theme's CartAddEvent so the
// drawer re-renders from those sections and the gift guard (assets/st-gift-guard.js) sees the change.
import { CartAddEvent, CartErrorEvent } from '@theme/events';

if (!window.__twCartUpsell) {
  window.__twCartUpsell = true;
  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-tw-upsell-add]') : null;
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();
    const id = Number(button.dataset.twUpsellAdd);
    if (!id) return;
    button.setAttribute('aria-busy', 'true');
    const sectionIds = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    try {
      const res = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sectionIds.join(','), sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (data.status) {
        console.warn('[tw-cart-upsell] add rejected:', data.description || data.message);
        button.dispatchEvent(new CartErrorEvent('', data.description || data.message || 'Add to cart failed', '', null));
        return;
      }
      button.dispatchEvent(new CartAddEvent({}, String(id), { source: 'tw-cart-upsell', itemCount: 1, sections: data.sections }));
    } catch (error) {
      console.error('[tw-cart-upsell]', error);
    } finally {
      button.removeAttribute('aria-busy');
    }
  });
}
